import { Spacer } from "@qivia/ui/src/designSystem/components/Spacer";
import { RowClickable } from "@qivia/ui";
import {
  EuroSymbolOutlined,
  MapOutlined,
  NearMeOutlined,
  RouteOutlined,
  ElectricBoltOutlined,
} from "@qivia/ui/src/designSystem/materialUi/materialUi";
import { useTranslation } from "react-i18next";

const FUEL_TOOLS_BASE = import.meta.env["VITE_FUEL_TOOLS_BASE_URL"] as string;
const EV_ROUTE_PLANNER_URL = import.meta.env[
  "VITE_EV_ROUTE_PLANNER_URL"
] as string;

export const FuelToolsMenuItems = () => {
  const { t } = useTranslation();

  return (
    <>
      <RowClickable
        text={t("driverPayment.fuelPrices")}
        subText={t("driverPayment.fuelPricesSub")}
        icon={<EuroSymbolOutlined />}
        onClick={() =>
          window.open(`${FUEL_TOOLS_BASE}qivia_prospect.html`, "_blank")
        }
      />
      <Spacer y={1} />
      <RowClickable
        text={t("driverPayment.fuelMap")}
        subText={t("driverPayment.fuelMapSub")}
        icon={<MapOutlined />}
        onClick={() =>
          window.open(`${FUEL_TOOLS_BASE}qivia_carte_mobile.html`, "_blank")
        }
      />
      <Spacer y={1} />
      <RowClickable
        text={t("driverPayment.nearbyStations")}
        subText={t("driverPayment.nearbyStationsSub")}
        icon={<NearMeOutlined />}
        onClick={() =>
          window.open(`${FUEL_TOOLS_BASE}qivia_proximite_mobile.html`, "_blank")
        }
      />
      <Spacer y={1} />
      <RowClickable
        text={t("driverPayment.fuelRoutePlanner")}
        subText={t("driverPayment.fuelRoutePlannerSub")}
        icon={<RouteOutlined />}
        onClick={() =>
          window.open(`${FUEL_TOOLS_BASE}qivia_route_mobile.html`, "_blank")
        }
      />
      <Spacer y={1} />
      <RowClickable
        text={t("driverPayment.evRoutePlanner")}
        subText={t("driverPayment.evRoutePlannerSub")}
        icon={<ElectricBoltOutlined />}
        onClick={() => window.open(EV_ROUTE_PLANNER_URL, "_blank")}
      />
      <Spacer y={1} />
    </>
  );
};
